import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import eComm3 from '../eComm_3.png';
import angry from '../angry.svg';
import reporting from '../chart-no-axes-combined.svg';
import systemDiagram from '../system-diagram.png';
import carousel from '../carousel.mp4';
import collections from '../cardcollection.mp4';
import coupons from '../promocodes.mp4';
import international from '../international.mp4';
import animation from '../animation.mp4';
import drawer from '../drawer.mp4';
import categories from '../categories.mp4';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { useScrollToTop } from '../hooks/useScrollToTop';
import './CaseStudy.css';

function CaseStudy3() {
  useScrollToTop();
  const [videoRef, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  useEffect(() => {
    if (isVisible && videoRef.current) {
      videoRef.current.play();
    }
  }, [isVisible, videoRef]);

  return (
    <div className="case-study-page">
      <div className="case-study-container">
        <Link to="/" className="back-button">
          <i className="fas fa-arrow-left"></i>
          <span>Back to all Projects</span>
        </Link>
        
        <div className="case-study-headline">
          <h1>Building an e-Learning marketplace for healthcare representatives to drive Direct-to-Consumer sales.</h1>
          <p className="internal-case-study-body">HealthStream offers applications, content, and solutions for developing healthcare representatives. The organization needed a better way to sell educational content direct to consumers rather than through hospital organizations (B2B).</p>
        </div>
        
        <div className="case-study-section">
          <div className="case-study-left-column">
            <div className="info-pair">
              <span className="info-label">Timeline</span>
              <span className="info-text">2019-2020</span>
            </div>
            <div className="info-pair">
              <span className="info-label">Tech Stack</span>
              <span className="info-text">zNode Headless-CMS, React Front-End</span>
            </div>
            <div className="info-pair">
              <span className="info-label">ICP Targeted</span>
              <span className="info-text">Healthcare Professionals outside of a Hospital Network</span>
            </div>
            <div className="info-pair">
              <span className="info-label">My Role</span>
              <span className="info-text">Product Management</span>
            </div>
          </div>
          
          <div className="case-study-right-column">
            <div className="section-content">
              <span className="info-label">Background</span>
              <h2>Scaling Direct-to-Consumer Medical Certification Sales</h2>
              <p className="internal-case-study-body">4.5 million healthcare professionals in the U.S. use HealthStream, the most widely-used healthcare ed-tech platform, for their medical certifications and continuing education. </p>
              <p className="internal-case-study-body">Over 40% of HealthStream’s user base is Nurses. In order to target other sectors of the healthcare workforce, they’d spent the resources to win exclusive content partnerships positioning themselves as the only vendor for specialty certifications. </p>
            </div>
          </div>
        </div>
        
        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <img src={eComm3} alt="Case Study 3" style={{ width: '100%', height: 'auto' }} />
        </div>

            <div className="margin-top-72 section-content">
              <span className="info-label">Problem to Solve</span>
              <h2>Outdated e-Commerce solution and evloving customer needs</h2>
            </div>

        <div className="case-study-section-slim margin-top-48">
          <div className="two-column-layout">
            <div className="column">
              <img src={angry} alt="Alert Icon" className="content-icon" />
              <h3 className="content-heading">Reducing Friction & Improving credibility</h3>
              <p className="internal-case-study-body">Outdated UI damaged HealthStream’s credibility and if the course material offered was the most up-to-date.</p>
            </div>
            <div className="column">
              <img src={reporting} alt="Monitor Icon" className="content-icon" />
              <h3 className="content-heading">Structured data for better reporting</h3>
              <p className="internal-case-study-body">Opportunity to better structure the catalog, highlight high-margin courses, and refine D2C sales strategies.</p>
            </div>
          </div>
        </div>

        <div className="case-study-section">
            <div className="section-content">
              <span className="info-label">Technical Approach</span>
              <h2>Building with a headless-CMS</h2>
              <ul className="internal-case-study-body">
                <li>Ability for back-end and front-end teams to work in parallel, enabling faster development cycles to meet our team’s tight deadlines. </li>
                <li>Scalable Architecture that could grow as we added more content and services to the HealthStream marketplace. </li>
                <li>Omnichannel capabilities that allow one content team to manage courses from a single SKU across all platforms.</li>
              </ul>
            </div>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <img src={systemDiagram} alt="Case Study 3" style={{ width: '100%', height: 'auto' }} />
        </div>

        <div className="margin-top-72 section-content">
              <span className="info-label">Solution</span>
              <h2>Better promotional tools for Marketing</h2>
              <h3>Homepage Carousel</h3>
              <p className="internal-case-study-body">We tested various carousel versions to promote products, events, and offers. The carousel was designed for accessibility, with auto-rotation stopping when users interacted with it, and mobile swipe support.</p>
              <h3>Promotional Course Collections</h3>
              <p className="internal-case-study-body">Admins could easily manage course collections through the CMS, adding/removing them without requiring deployment. </p>
              <h3>Coupon Codes</h3>
              <p className="internal-case-study-body">We added normal and unique coupon codes, boosting conversion rates, customer acquisition, and retention.</p>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={carousel} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={collections} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={coupons} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 section-content">
              <span className="info-label">Solution</span>
              <h2>Reducing checkout friction</h2>
              <h3>Merge Cart</h3>
              <p className="internal-case-study-body">Customers could add items to their cart from any device, ensuring they wouldn’t lose their selections on shared devices.</p>
              <h3>International Payments</h3>
              <p className="internal-case-study-body">Added support for Canadian customers, with Payflow handling currency conversions and tax calculations based on the customer's location. </p>
              <h3>Loading Animation</h3>
              <p className="internal-case-study-body">To prevent rage clicks on the 'Place Order' button, we added a custom loading animation during order processing.</p>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%' }}>
          <video 
            ref={videoRef}
            src={international} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={animation} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 section-content">
              <span className="info-label">Solution</span>
              <h2>Improving course findability</h2>
              <h3>Product Drawer</h3>
              <p className="internal-case-study-body">Replaced the outdated navigation with a drawer to categorize products more effectively.</p>
              <h3>Product Categories</h3>
              <p className="internal-case-study-body">Added filters for care setting, discipline, and partner, aligning with how healthcare professionals search for relevant content. </p>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={drawer} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="margin-top-72 image-container" style={{ width: '100%'}}>
          <video 
            ref={videoRef}
            src={categories} 
            controls 
            muted
            style={{ width: '100%', height: 'auto' }}
            alt="Homepage Carousel Demo"
          >
            Your browser does not support the video tag.
          </video>
        </div>

      </div>
    </div>
  );
}

export default CaseStudy3;

